












































































































































































































































































import { Component, Emit, Model, Prop, PropSync, Vue, Watch, Ref} from 'vue-property-decorator';
import { getModule } from "vuex-module-decorators";
import { Urls } from '@/Urls';
//@ts-ignore
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap';
import StarterKit from 'tiptap';
import AudioImporter from '@/components/common/AudioImporter.vue';
import { API, Storage } from 'aws-amplify';
import TagMenu from '@/components/comments/TagMenu.vue';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";


// @formatter:off
//@ts-ignore
import {
    Bold,
    BulletList,
    CodeBlock,
    History,
    Italic,
    Link,
    ListItem,
    OrderedList,
    Underline,
    Heading,
    HardBreak,
    Code,
    Strike,
    Table,
    TableRow,
    TableCell,
    TableHeader,
} from 'tiptap-extensions';
import Iframe from '@/components/common/Iframe.js';
import CustomImage from '@/components/common/TipTapImage.js';
import Audio from '@/components/common/Audio.js';
import { isatty } from 'tty';

// @formatter:on
const workspaceOptions = getModule(WorkspaceOptions)

@Component({
    components: {
        EditorContent,
        EditorMenuBar,
        EditorMenuBubble,
        TagMenu,
    },
})
export default class CommentEditor extends Vue {
    @Model('updated:value')
    value!: string;

    @Prop({ default: false, type: Boolean })
    autoSave!: boolean;

    @Prop({ default: false, type: Boolean })
    isAppendComment!: boolean;

    @Prop({ default: 'HTML', type: String })
    outputFormat!: 'HTML' | 'JSON';

    @Prop({ default: 'RICH', type: String })
    editorType!: String;

    @Prop({ default: false, type: Boolean })
    alwaysOpen!: boolean;

    @Prop({ default: false, type: Boolean })
    open!: boolean;

    @Prop({ default: false, type: Boolean })
    readonly!: boolean;

    @Prop({ default: false, type: Boolean })
    autofocus!: boolean;

    @Prop({ default: '', type: String })
    minWidth!: string;

    @Prop({ default: '', type: String })
    maxWidth!: string;

    @Prop({ default: '', type: String })
    width!: string;

    @Prop({ default: '', type: String })
    maxHeight!: string;

    @Prop({ default: 0, type: Number })
    topMargin!: number;

    @Prop({ default: 28, type: Number })
    tableBarTopMargin!: number;

    @Prop({ default: false, type: Boolean })
    saveBtnDisabled!: boolean;

    @Prop({ default: false, type: Boolean })
    saveBtnloading!: boolean;

    @Prop({
        default: () => {
            return [];
        },
        type: Array,
    })
    selectedTags!: any;

    @Prop({ default: 0, type: Number })
    clearInc!: number;

    @Prop({
        default: () => {
            return [];
        },
        type: Array,
    })
    allTags!: any;

    @PropSync('audioKeys', {
        default: () => {
            return [];
        },
        type: Array,
    })
    audioKeysSync!: any;

    @Ref()
    urlInput:HTMLInputElement;

    private readonly URLS = Urls;
    private newContent: string = this.value || '';
    private active = false;
    private linkUrl = null;
    private linkMenuIsActive = false;
    private openTable = false;
    private isRaw = false;
    private menuBubble = false;
    private urlBar = 0;

    get commentVertical(){
        return workspaceOptions.commentVertical;
    }

    get editComments() {
        return workspaceOptions.editComments;
    }

    mounted() {
        if (this.alwaysOpen) {
            this.active = true;
        }
        this.editor = this.getEditor();
        if (this.autofocus) {
            this.editor.focus();
        }
    }

    @Watch('active')
    private onActiveChange(newVal: boolean, oldVal: boolean) {
        if (newVal && this.editor) {
            this.editor.setContent(this.value);
            if (this.autofocus) this.editor.focus();
        }
    }

    @Watch('value')
    private onValueChange() {
        if (this.active && this.editor && !this.editor.focused) {
            this.editor.setContent(this.value);
        }
    }

    @Watch('newContent')
    private onNewContentChange(newVal: string) {
        if (this.autoSave) {
            this.update();
        }
    }

    private getTextAreaStyle() {
        return (
            'min-width:' + this.minWidth + '; max-width:' + this.maxWidth + '; width:' + this.width
        );
    }

    private editor: any = null;

    private getEditor() {
        return new Editor({
            extensions: [
                new BulletList(),
                new CodeBlock(),
                new ListItem(),
                new OrderedList(),
                new Link({ target: '_blank', openOnClick: false }),
                new Bold(),
                new Italic(),
                new Underline(),
                new History(),
                new HardBreak(),
                new CustomImage(),
                new Heading({ levels: [1, 2, 3] }),
                new Code(),
                new Strike(),
                new Table({
                    resizable: true,
                }),
                new TableRow(),
                new TableHeader(),
                new TableCell(),
                new Iframe(),
                new Audio(),
            ],
            content: this.value,
            //@ts-ignore
            onUpdate: ({ getHTML, getJSON }) => {
                let content = getHTML(),
                    json = getJSON().content;

                if (Array.isArray(json) && json.length === 1 && json[0].type === 'paragraph') {
                    if (!json[0].hasOwnProperty('content')) {
                        content = ''; // or any other default value
                    } else {
                        content = content.replace('<p>', '').replace('</p>', '');
                    }
                }
                // get new content on update
                if (this.outputFormat === 'HTML') this.newContent = content;
                else if (this.outputFormat === 'JSON') this.newContent = json;
            },
        });
    }

    private addAudio(event: any, command: any) {
        // console.log(event);
        this.audioKeysSync.push(event.key);
        Storage.get(event.key).then((res) => {
            const src = res.toString();
            const type = event.type;
            const name = event.name;
            // console.log(src);
            if (src !== null) {
                command({ src, type, name });
            }
        });
    }

    private insertTable(editor, commands, isActive) {
        console.log(editor);
        console.log(commands);
        console.log(isActive);
    }

    private showLinkBar(attrs: any){
        if (this.urlBar === 1) {
            this.urlBar = 0;
            this.linkUrl = null;
        } else {
            if(attrs && attrs.href){
                this.linkUrl = attrs.href;
            }
            this.urlBar = 1;
            this.$nextTick(() => {
                this.urlInput.focus();
            });
        }
    }
    private addLink(commands:any){
        if(this.urlBar === 1){
            this.setLinkUrl(commands.link)
        } else if (this.urlBar === 2){
            this.addImageUrl(commands.image)
        } else if (this.urlBar === 3){
            this.addVideo(commands.iframe)
        }
    }
    private setLinkUrl(command: any, target: string = '_blank') {
        const src = this.linkUrl;
        command({href: src, target: target});
        this.urlBar=0;
        this.linkUrl = null;
    }
    
    private removeLinkUrl(command: any){
        command({});
        this.urlBar=0;
        this.linkUrl = null;
    }

    private showImageUrlBar(){
        if (this.urlBar === 2) {
            this.urlBar = 0;
            this.linkUrl = null;
        } else {
            this.urlBar = 2;
            this.$nextTick(() => {
                this.urlInput.focus();
            });
        }
        
    }

    private addImageUrl(command:any){
        const src = this.linkUrl;
        if (src){
            command({src});
        }
        this.urlBar=0;
        this.linkUrl = null;
    }

    private showVideoUrlBar(){
        if (this.urlBar === 3) {
            this.urlBar = 0;
            this.linkUrl = null;
        } else {
            this.urlBar = 3;
            this.$nextTick(() => {
                this.urlInput.focus();
            });
        }
    }
    private addVideo(command:any){
        let src = this.linkUrl;
        if (src !== null) {
            src = src.replace( '/watch?v=', '/embed/' );
            command({src});
        }
        this.urlBar=0;
        this.linkUrl = null;
    }

    @Emit('update')
    @Emit('updated:value')
    private update() {
        return this.newContent;
    }

    @Emit('save')
    @Emit('updated:value')
    private save() {
        if (!this.alwaysOpen) {
            this.active = false;
        }
        return this.newContent;
    }

    @Emit('cancel')
    private cancel() {
        if (!this.alwaysOpen) {
            this.active = false;
        }
        this.linkMenuIsActive = false;
        this.newContent = this.value;
    }

    beforeDestroy() {
        if (this.editor) this.editor.destroy();
    }
}
